export function rgbToHex(r, g, b) {
  const u2Hex = u => {
    let hex = u.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }
  
  return `#${u2Hex(r)}${u2Hex(g)}${u2Hex(b)}`
}

export default (hex, encodeHex=false) => {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function(m, r, g, b) {
      return r + r + g + g + b + b;
  });

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) {
    return encodeHex ? '#000000' : 'rbg(0, 0, 0)'
  }

  const intensity = Math.round(
    0.3 * parseInt(result[1], 16) + 
    0.59 * parseInt(result[2], 16) +
    0.11 * parseInt(result[3], 16))
  return encodeHex 
    ? rgbToHex(intensity, intensity, intensity)
    : `rgb(${intensity}, ${intensity}, ${intensity})` ;
}